import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import koLocale from 'date-fns/locale/ko';
import {
  Box,
  Button,
  Chip,
  styled,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  title?: string;
  selectedDate: any;
  setSelectedDate: Dispatch<SetStateAction<any>>;
  disabled?: boolean;
  minDate?: any;
  maxDate?: any;
}

const DateTextField = styled(TextField)({
  '& .MuiInputLabel-root': { top: '-5px' },
  '& .MuiOutlinedInput-root': { pr: '1rem' },
  width: '20rem',
});

const DateChip = styled(Chip)({
  margin: '.5em',
  backgroundColor: 'rgba(0, 162, 255, 0.1)',
  borderColor: 'rgba(0, 162, 255, 0.5)',
  '& .MuiChip-deleteIcon': {
    fontSize: '1rem',
  },
});

const DateAddButton = styled(Button)({
  marginTop: '.3rem',
  marginLeft: '.7rem',
  padding: '.1rem 0',
  borderRadius: '20px',
});

export const SwDatePicker: React.FC<Props> = ({
  title = '',
  selectedDate,
  setSelectedDate,
  disabled = false,
  minDate,
  maxDate,
}) => {
  const [date, setDate] = useState<Date | null>(selectedDate);

  const handleChange = (time: any) => {
    setDate(time);
    setSelectedDate(time);
  };

  useEffect(() => {
    setDate(selectedDate);
  }, [selectedDate]);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={koLocale}
        >
          <DatePicker
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
            inputFormat='yyyy-MM-dd'
            renderInput={props => <DateTextField {...props} />}
            label={title}
            value={date}
            onChange={handleChange}
          />
        </LocalizationProvider>
      </Box>
    </>
  );
};
